/*
 * @Author: kangzhuang 742291831@qq.com
 * @Date: 2025-04-07 14:44:09
 * @LastEditors: kangzhuang 742291831@qq.com
 * @LastEditTime: 2025-04-16 11:56:05
 * @FilePath: \look-exhibition-hall\src\store\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from "vue";
import Vuex from "vuex";
import user from "./user";

Vue.use(Vuex);

export default new Vuex.Store({
	state: {},
	getters: {},
	mutations: {},
	actions: {},
	modules: {
		user
	}
});
